import React from "react";
import PropTypes from "prop-types";
import PanelListWrapper from "../PanelListWrapper";

import ElementWrapper from "../styles/ElementWrapper";
import MServicesItem from "./MServicesItem";

const MServicesList = ({ services }) => {
  if (services.length === 0) {
    return (
      <ElementWrapper className="p-3">
        <h1>Lo sentimos, no encontramos nada</h1>
      </ElementWrapper>
    );
  }

  return (
    <PanelListWrapper>
      <thead>
        <tr>
          <th>Nombre</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        {services.map(service => (
          <MServicesItem key={service.id} service={service} />
        ))}
      </tbody>
    </PanelListWrapper>
  );
};

MServicesList.propTypes = {
  services: PropTypes.array.isRequired
};

export default MServicesList;
